import React, { type AriaAttributes, type FC } from 'react'
import { Tooltip } from '@mui/material'

import type { BaseCommonProps } from '../common'
import { type AbsoluteRouteOnlyPath, ForwardRefPermissionedLink, PermissionedLink } from '../routing'
import type { ReadonlyPropsWithChildren } from '../utils'
import { useNavigationFormatter } from './Hooks'

const Wrapper: FC<ReadonlyPropsWithChildren<{ authorized: boolean }>> = ({ authorized, children }) => (authorized ? <>{children}</> : null)

type Props = ReadonlyPropsWithChildren<{ path: AbsoluteRouteOnlyPath, withTooltip?: boolean } & Pick<AriaAttributes, 'aria-current'> & BaseCommonProps>

export const NavigationPermissionedLink: FC<Props> = ({
    path,
    withTooltip,
    ...rest
}) => {
    const formatter = useNavigationFormatter()

    return withTooltip
        ? (
            <Tooltip title={formatter.formatTitle(path)} placement="right">
                <ForwardRefPermissionedLink path={path} color="inherit" wrapper={Wrapper} {...rest} />
            </Tooltip>
        )
        : <PermissionedLink path={path} color="inherit" title={formatter.formatDescription(path) ?? undefined} wrapper={Wrapper} {...rest} />
}
